import React, { FunctionComponent } from 'react'
// @ts-ignore
import { FixedSizeList as List } from 'react-window'

import { GenresSelectItem, ListWrapper } from './styles'

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
const MenuList: FunctionComponent<any> = ({
  options,
  children,
  maxHeight,
  getValue,
}) => {
  const height = 48
  const [value] = getValue()
  const initialOffset = options.indexOf(value) * height

  return (
    <ListWrapper>
      <List
        height={maxHeight && maxHeight}
        itemCount={children.length}
        itemSize={height}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }: { index: number; style: React.CSSProperties }) => (
          <GenresSelectItem style={style}>{children[index]}</GenresSelectItem>
        )}
      </List>
    </ListWrapper>
  )
}

export default MenuList
